import backend, {LOOM_API} from 'utils/backend/loom/api_library';

import queryString from 'query-string';

import {
  adaptLoomCaregiverDetail,
  adaptLoomCaregiverList,
  toLoomCaregiverListQuery,
} from './caregiver_adapter';

const loomApi = () => {
  if (!LOOM_API) {
    throw new Error('REACT_APP_LOOM_API must be configured before Loom caregiver reads can be enabled.');
  }

  return LOOM_API.replace(/\/$/, '');
};

const queryCaregiver = async (filters, sort, cursor, options = {}) => {
  const query = queryString.stringify(
      toLoomCaregiverListQuery(filters, sort, cursor, options),
      {skipNull: true, skipEmptyString: true},
  );
  const response = await backend.get(`${loomApi()}/api/careos/caregivers?${query}`);
  return adaptLoomCaregiverList(response);
};

const getCaregiver = async (caregiverRn) => {
  const response = await backend.get(
      `${loomApi()}/api/careos/caregivers/${encodeURIComponent(caregiverRn)}`,
  );
  return adaptLoomCaregiverDetail(response);
};

export default {
  getCaregiver,
  queryCaregiver,
};
